export const AppDownloadBannerSection = () => {
  return (
    <section className="w-full flex justify-center relative">

      {/* CARD */}
      <div
        className="
          relative
          w-full
          max-w-[1700px]
          rounded-[48px]
          overflow-hidden
          
          
          flex
          items-center
          justify-between
          bg-gradient-to-br
          from-[#8F0000]
          via-[#D40000]
          to-[#FF0000]
        "
      >

        {/* LEFT SIDE */}
        <div className="max-w-[640px] text-white z-10 py-10 pl-[120px]">

          <h2 className="
            text-[64px]
            leading-[72px]
            font-semibold
            mb-6
          ">
            Ready to
            <br />
            Experience More?
          </h2>


          <p className="
            text-[20px]
            text-white/90
            leading-[34px]
            mb-10
          ">
           Join the community of Canadians discovering better deals, earning real rewards, and supporting the local businesses that make their city great.
          </p>


          {/* STORE BUTTONS */}
          <div className="flex gap-5">

            {/* APP STORE */}
            <a
              href="https://couponbook.app.link/BsnZ5PEfH2b"
              target="_blank"
              rel="noopener noreferrer"
              className="
                flex items-center
                bg-black
                px-6
                py-3
                rounded-full
                hover:opacity-90
                transition
              "
            >
              <img
                src="/images/AppleLogo.webp"
                className="h-7"
                alt="Google Play"
              />
            </a>


            {/* GOOGLE PLAY */}
            <a
              href="https://couponbook.app.link/BsnZ5PEfH2b"
              target="_blank"
              rel="noopener noreferrer"
              className="
                flex items-center
                bg-black
                px-6
                py-3
                rounded-full
                hover:opacity-90
                transition
              "
            >
              <img
                src="/images/rectangle-34625679.webp"
                className="h-7"
                alt="Google Play"
              />
            </a>

          </div>

        </div>



        {/* RIGHT SIDE */}
        <div className="relative flex items-center justify-center pr-[120px]">

          {/* glow */}
          <div
            className="
              absolute
              bottom-[-120px]
              right-[0px]
              w-[600px]
              h-[600px]
              bg-black/25
              blur-[200px]
              rounded-full
            "
          />

          {/* PHONE */}
          <img
            src="/images/Webp/group-2085663667.webp"
            alt="App preview"
            className="
              relative
              bottom-0
              max-w-[520px]
              object-contain
            "
          />

        </div>


      </div>

    </section>
  );
};